import Vue from 'vue'
import VueDraggable from 'vuedraggable'

import { installCoreComponents } from './components/install'
import detectIE from '../common/detectIE'

import '../common/plugins'
import './plugins/vue-meta'

import router from './router'
import App from './App.vue'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

Vue.config.productionTip = false
installCoreComponents(Vue)

UIkit.use(Icons)
Vue.component('vue-draggable', VueDraggable)

const ieVersion = detectIE()
if (ieVersion && ieVersion <= 11) {
  document.getElementById('ie-message').style.display = 'block'
} else {
  // @ts-ignore
  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')
}
